export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'action', name: '动作冒险', icon: 'ri-sword-line' },
  { slug: 'suspense', name: '悬疑惊悚', icon: 'ri-search-eye-line' },
  { slug: 'scifi', name: '科幻奇幻', icon: 'ri-rocket-line' },
  { slug: 'drama', name: '剧情爱情', icon: 'ri-heart-line' },
  { slug: 'crime', name: '犯罪刑侦', icon: 'ri-police-car-line' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
];

export interface TvShow {
  id: number;
  name: string;
  englishName: string;
  poster: string;
  banner: string;
  categories: string[];
  rating: number;
  year: number;
  seasons: number;
  episodes: number;
  status: string;
  description: string;
  featured: boolean;
  latest: boolean;
  latestEpisode: string;
  updateTime: string;
  director: string;
  cast: string[];
  episodeList: { season: number; episodes: { num: number; title: string; }[] }[];
}

export const tvShows: TvShow[] = [
  {
    id: 1,
    name: '权力的游戏',
    englishName: 'Game of Thrones',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20television%20series%20poster%20featuring%20a%20dramatic%20iron%20throne%20made%20of%20swords%20silhouetted%20against%20a%20dark%20stormy%20sky%20with%20crimson%20and%20gold%20tones%2C%20medieval%20castle%20ruins%20in%20the%20distance%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20highly%20detailed%20promotional%20fantasy%20artwork%2C%20rich%20textured%20background%2C%20dark%20moody%20atmosphere%20with%20fiery%20glow%2C%20professional%20movie%20poster%20composition&width=800&height=1200&seq=got-poster-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20landscape%20of%20a%20medieval%20fantasy%20kingdom%20with%20towering%20castle%20walls%2C%20dragons%20flying%20in%20stormy%20orange%20and%20crimson%20sky%2C%20snowy%20mountains%20in%20the%20distance%2C%20dramatic%20lighting%2C%20grand%20scale%20fantasy%20world%2C%20rich%20dark%20fantasy%20atmosphere%2C%20professional%20cinematic%20wide%20shot%2C%20highly%20detailed%20fantasy%20art&width=1600&height=900&seq=got-banner-01&orientation=landscape',
    categories: ['action', 'scifi', 'drama'],
    rating: 9.4,
    year: 2011,
    seasons: 8,
    episodes: 73,
    status: '已完结',
    description: '《权力的游戏》改编自乔治·R·R·马丁的奇幻小说系列《冰与火之歌》，讲述了在虚构的维斯特洛大陆上，几大家族为争夺铁王座而展开的权力斗争。剧集以其宏大的世界观、复杂的人物关系和出人意料的情节转折征服了全球观众，成为HBO历史上最成功的剧集之一。',
    featured: true,
    latest: false,
    latestEpisode: '第八季 第6集',
    updateTime: '2019-05-20',
    director: '大卫·贝尼奥夫 / D·B·威斯',
    cast: ['基特·哈灵顿', '艾米莉亚·克拉克', '彼特·丁拉基', '琳娜·海蒂', '尼古拉·科斯特-瓦尔道'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 10 }, (_, i) => ({ num: i + 1, title: `凛冬将至 - 第${i + 1}集` })) },
      { season: 8, episodes: Array.from({ length: 6 }, (_, i) => ({ num: i + 1, title: `最终季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 2,
    name: '绝命毒师',
    englishName: 'Breaking Bad',
    poster: 'https://readdy.ai/api/search-image?query=Intense%20crime%20drama%20television%20series%20poster%20featuring%20a%20solitary%20figure%20in%20yellow%20hazmat%20suit%20standing%20in%20vast%20New%20Mexico%20desert%20landscape%20under%20harsh%20golden%20sunlight%2C%20warm%20amber%20and%20muted%20sage%20green%20color%20palette%2C%20gritty%20realistic%20cinematic%20composition%2C%20atmospheric%20dust%20particles%20floating%20in%20golden%20hour%20light%2C%20minimalist%20professional%20poster%20design%20with%20dramatic%20tension&width=800&height=1200&seq=bb-poster-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20vast%20American%20southwest%20desert%20landscape%20under%20golden%20sunset%2C%20a%20lone%20RV%20camper%20parked%20on%20an%20empty%20highway%20stretching%20to%20the%20horizon%2C%20warm%20amber%20and%20dusty%20orange%20tones%2C%20dramatic%20clouds%2C%20cinematic%20atmosphere%2C%20professional%20film%20photography%20quality&width=1600&height=900&seq=bb-banner-02&orientation=landscape',
    categories: ['crime', 'drama', 'suspense'],
    rating: 9.6,
    year: 2008,
    seasons: 5,
    episodes: 62,
    status: '已完结',
    description: '《绝命毒师》讲述了一位普通的高中化学老师沃尔特·怀特在得知自己身患绝症后，为了给家人留下财产，利用自己的化学知识制造冰毒，逐渐走上犯罪道路的故事。该剧被誉为21世纪最伟大的电视剧之一，布莱恩·科兰斯顿的表演堪称教科书级别。',
    featured: true,
    latest: false,
    latestEpisode: '第五季 第16集',
    updateTime: '2013-09-29',
    director: '文斯·吉里根',
    cast: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯', '贝琪·勃兰特'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 7 }, (_, i) => ({ num: i + 1, title: `第一季 - 第${i + 1}集` })) },
      { season: 5, episodes: Array.from({ length: 16 }, (_, i) => ({ num: i + 1, title: `最终季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 3,
    name: '怪奇物语',
    englishName: 'Stranger Things',
    poster: 'https://readdy.ai/api/search-image?query=Retro%201980s%20science%20fiction%20horror%20television%20series%20poster%20featuring%20a%20group%20of%20kids%20on%20bicycles%20riding%20through%20a%20dark%20suburban%20street%20at%20night%20under%20a%20mysterious%20red%20glowing%20sky%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20vintage%20Spielberg%20style%20adventure%20atmosphere%2C%20mysterious%20paranormal%20energy%2C%20nostalgic%20cinematic%20composition%20with%20warm%20and%20eerie%20tones&width=800&height=1200&seq=st-poster-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%201980s%20American%20suburban%20neighborhood%20at%20twilight%20with%20eerie%20red%20and%20purple%20sky%2C%20bicycle%20silhouettes%2C%20retro%20street%20lamps%20glowing%2C%20mysterious%20paranormal%20atmosphere%2C%20nostalgic%20vintage%20film%20aesthetic%2C%20cinematic%20professional%20photography&width=1600&height=900&seq=st-banner-03&orientation=landscape',
    categories: ['scifi', 'horror', 'suspense'],
    rating: 9.0,
    year: 2016,
    seasons: 5,
    episodes: 42,
    status: '已完结',
    description: '《怪奇物语》背景设定在1980年代的印第安纳州，讲述了一个小男孩神秘失踪后，他的朋友、家人和当地警察卷入了一系列超自然事件的故事。剧集完美融合了科幻、恐怖和青春成长元素，向80年代流行文化致敬。',
    featured: true,
    latest: false,
    latestEpisode: '第五季 第8集',
    updateTime: '2025-11-27',
    director: '达菲兄弟',
    cast: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯', '加滕·马塔拉佐'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `第一季 - 第${i + 1}集` })) },
      { season: 5, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `最终季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 4,
    name: '行尸走肉',
    englishName: 'The Walking Dead',
    poster: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20zombie%20horror%20television%20series%20poster%20featuring%20a%20lone%20survivor%20walking%20through%20a%20desolate%20destroyed%20city%20street%20with%20abandoned%20cars%20and%20crumbling%20buildings%2C%20dark%20gray%20and%20muted%20green%20color%20palette%2C%20eerie%20atmospheric%20fog%2C%20dramatic%20survival%20tension%2C%20professional%20poster%20composition%20with%20gritty%20realistic%20style&width=800&height=1200&seq=twd-poster-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20post%20apocalyptic%20abandoned%20city%20street%20overgrown%20with%20vegetation%2C%20broken%20windows%20and%20rusted%20cars%2C%20dark%20stormy%20sky%2C%20mysterious%20fog%20rolling%20through%20empty%20streets%2C%20survival%20horror%20atmosphere%2C%20professional%20film%20photography%2C%20desaturated%20muted%20tones&width=1600&height=900&seq=twd-banner-04&orientation=landscape',
    categories: ['horror', 'drama', 'action'],
    rating: 8.7,
    year: 2010,
    seasons: 11,
    episodes: 177,
    status: '已完结',
    description: '《行尸走肉》讲述了警察瑞克·格莱姆斯从昏迷中醒来后发现世界已被丧尸占领，他带领一群幸存者在末日世界中艰难求生的故事。这部AMC的旗舰剧集以对人性的深刻探讨而闻名，展现了极端环境下人类的道德抉择。',
    featured: false,
    latest: false,
    latestEpisode: '第十一季 第24集',
    updateTime: '2022-11-20',
    director: '弗兰克·德拉邦特',
    cast: ['安德鲁·林肯', '诺曼·瑞杜斯', '梅丽莎·麦克布莱德', '劳伦·科汉', '达娜·古瑞拉'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 6 }, (_, i) => ({ num: i + 1, title: `末日降临 - 第${i + 1}集` })) },
      { season: 11, episodes: Array.from({ length: 24 }, (_, i) => ({ num: i + 1, title: `终章 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 5,
    name: '黑镜',
    englishName: 'Black Mirror',
    poster: 'https://readdy.ai/api/search-image?query=Dystopian%20science%20fiction%20anthology%20television%20series%20poster%20featuring%20a%20cracked%20dark%20reflective%20glass%20surface%20with%20fragmented%20digital%20pixelated%20patterns%20and%20glitch%20effects%2C%20minimalist%20dark%20metallic%20tones%20with%20electric%20cyan%20and%20crimson%20accents%2C%20futuristic%20technological%20horror%20aesthetic%2C%20sleek%20professional%20poster%20design%20with%20unsettling%20atmosphere&width=800&height=1200&seq=bm-poster-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20abstract%20composition%20of%20shattered%20dark%20glass%20panels%20floating%20in%20digital%20void%2C%20neon%20circuit%20lines%20and%20data%20streams%20creating%20technological%20dystopia%20atmosphere%2C%20dark%20minimalist%20aesthetic%20with%20subtle%20cyan%20and%20crimson%20light%20reflections%2C%20professional%20cinematic%20abstract%20art&width=1600&height=900&seq=bm-banner-05&orientation=landscape',
    categories: ['scifi', 'suspense', 'drama'],
    rating: 9.1,
    year: 2011,
    seasons: 6,
    episodes: 28,
    status: '连载中',
    description: '《黑镜》是一部独立的单元剧系列，每一集都探讨了现代科技对社会和人性的影响。从社交媒体评分系统到意识上传，剧集以犀利的视角审视了科技发展可能带来的黑暗面，令人深思且不寒而栗。',
    featured: false,
    latest: true,
    latestEpisode: '第六季 第5集',
    updateTime: '2025-12-15',
    director: '查理·布鲁克',
    cast: ['布莱丝·达拉斯·霍华德', '乔恩·哈姆', '麦肯兹·戴维斯', '安德鲁·斯科特', '安东尼·麦凯'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 3 }, (_, i) => ({ num: i + 1, title: `第一季 - 第${i + 1}集` })) },
      { season: 6, episodes: Array.from({ length: 5 }, (_, i) => ({ num: i + 1, title: `第六季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 6,
    name: '西部世界',
    englishName: 'Westworld',
    poster: 'https://readdy.ai/api/search-image?query=Science%20fiction%20western%20television%20series%20poster%20featuring%20a%20dramatic%20sunset%20silhouette%20of%20a%20lone%20figure%20on%20horseback%20against%20the%20vast%20desert%20canyon%20landscape%2C%20warm%20golden%20and%20deep%20crimson%20tones%20with%20futuristic%20mechanical%20skeletal%20structure%20barely%20visible%20beneath%20the%20surface%2C%20philosophical%20dystopian%20atmosphere%2C%20professional%20cinematic%20poster%20design&width=800&height=1200&seq=ww-poster-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20vast%20American%20western%20desert%20canyon%20landscape%20during%20golden%20sunset%2C%20majestic%20rock%20formations%20with%20dramatic%20shadows%2C%20a%20lone%20horse%20rider%20silhouette%20on%20the%20ridge%2C%20warm%20orange%20and%20crimson%20sky%2C%20philosophical%20and%20mysterious%20atmosphere%2C%20professional%20film%20photography&width=1600&height=900&seq=ww-banner-06&orientation=landscape',
    categories: ['scifi', 'action', 'suspense'],
    rating: 8.8,
    year: 2016,
    seasons: 4,
    episodes: 36,
    status: '已完结',
    description: '《西部世界》设定在一个以美国西部为主题的未来高科技成人乐园中，园中的"接待员"是高度仿真的人工智能机器人。剧集探讨了意识、自由意志和人性的本质，其复杂的叙事结构和哲学深度令人惊叹。',
    featured: false,
    latest: false,
    latestEpisode: '第四季 第8集',
    updateTime: '2022-08-14',
    director: '乔纳森·诺兰 / 丽莎·乔伊',
    cast: ['埃文·蕾切尔·伍德', '桑迪·牛顿', '杰弗里·怀特', '艾德·哈里斯', '泰莎·汤普森'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 10 }, (_, i) => ({ num: i + 1, title: `迷宫 - 第${i + 1}集` })) },
      { season: 4, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `第四季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 7,
    name: '风骚律师',
    englishName: 'Better Call Saul',
    poster: 'https://readdy.ai/api/search-image?query=Legal%20crime%20drama%20television%20series%20poster%20featuring%20a%20man%20in%20a%20colorful%20mismatched%20suit%20standing%20alone%20on%20an%20empty%20desert%20highway%20holding%20a%20briefcase%2C%20warm%20golden%20New%20Mexico%20sunlight%20casting%20long%20dramatic%20shadows%2C%20muted%20earth%20tones%20with%20subtle%20pop%20of%20colorful%20pattern%2C%20bittersweet%20professional%20poster%20composition%20with%20character%20study%20atmosphere&width=800&height=1200&seq=bcs-poster-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20an%20empty%20desert%20two%20lane%20highway%20stretching%20to%20the%20horizon%20under%20bright%20New%20Mexico%20sun%2C%20a%20single%20strip%20mall%20in%20the%20distance%2C%20warm%20golden%20and%20dusty%20earth%20tones%2C%20nostalgic%20and%20melancholic%20atmosphere%2C%20professional%20film%20photography&width=1600&height=900&seq=bcs-banner-07&orientation=landscape',
    categories: ['crime', 'drama', 'comedy'],
    rating: 9.3,
    year: 2015,
    seasons: 6,
    episodes: 63,
    status: '已完结',
    description: '《风骚律师》是《绝命毒师》的前传衍生剧，讲述了小律师吉米·麦吉尔如何一步步蜕变成游走在法律边缘的"索尔·古德曼"。鲍勃·奥登科克贡献了令人惊叹的表演，剧集在人物刻画和叙事上达到了新的高度。',
    featured: false,
    latest: false,
    latestEpisode: '第六季 第13集',
    updateTime: '2022-08-15',
    director: '文斯·吉里根 / 彼得·古尔德',
    cast: ['鲍勃·奥登科克', '乔纳森·班克斯', '蕾亚·塞洪', '帕特里克·法比安', '迈克尔·曼多'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 10 }, (_, i) => ({ num: i + 1, title: `开端 - 第${i + 1}集` })) },
      { season: 6, episodes: Array.from({ length: 13 }, (_, i) => ({ num: i + 1, title: `终章 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 8,
    name: '切尔诺贝利',
    englishName: 'Chernobyl',
    poster: 'https://readdy.ai/api/search-image?query=Historical%20drama%20miniseries%20poster%20featuring%20a%20dramatic%20industrial%20nuclear%20power%20plant%20silhouette%20against%20a%20sickly%20yellow%20and%20toxic%20green%20radioactive%20sky%2C%20ominous%20dark%20smoke%20rising%20from%20the%20reactor%2C%20soviet%20era%20brutalist%20architecture%2C%20haunting%20and%20somber%20atmosphere%2C%20professional%20documentary%20style%20poster%20with%20historical%20tragedy%20aesthetic%2C%20muted%20desaturated%20palette&width=800&height=1200&seq=ch-poster-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20an%20abandoned%20soviet%20era%20industrial%20landscape%20with%20cooling%20tower%20silhouettes%20against%20a%20sickly%20yellow%20toxic%20sky%2C%20haunting%20empty%20streets%20of%20Pripyat%2C%20eerie%20radioactive%20atmosphere%2C%20muted%20desaturated%20tones%2C%20professional%20documentary%20film%20photography&width=1600&height=900&seq=ch-banner-08&orientation=landscape',
    categories: ['drama', 'suspense'],
    rating: 9.5,
    year: 2019,
    seasons: 1,
    episodes: 5,
    status: '已完结',
    description: '《切尔诺贝利》以1986年苏联切尔诺贝利核电站灾难为背景，真实还原了这场人类历史上最严重的核事故。剧集深刻揭示了谎言的代价和真相的力量，每一帧画面都充满了沉重与压迫感，是HBO的又一神作。',
    featured: false,
    latest: false,
    latestEpisode: '第5集',
    updateTime: '2019-06-03',
    director: '约翰·伦克',
    cast: ['杰瑞德·哈里斯', '斯特兰·斯卡斯加德', '艾米丽·沃森', '保罗·里特', '杰西·巴克利'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 5 }, (_, i) => ({ num: i + 1, title: ['1:23:45', '请保持冷静', '敞开吧，大地', '全人类的幸福', '永恒的安息'][i] })) },
    ],
  },
  {
    id: 9,
    name: '猎魔人',
    englishName: 'The Witcher',
    poster: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20television%20series%20poster%20featuring%20a%20silver%20haired%20monster%20hunter%20with%20cat%20eyes%20wielding%20two%20swords%20on%20his%20back%2C%20standing%20on%20a%20rocky%20cliff%20edge%20overlooking%20a%20medieval%20fantasy%20kingdom%20at%20dusk%2C%20dramatic%20storm%20clouds%20with%20silver%20and%20black%20tones%2C%20professional%20cinematic%20fantasy%20poster%2C%20gritty%20and%20atmospheric%20medieval%20dark%20fantasy%20aesthetic&width=800&height=1200&seq=tw-poster-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20dark%20medieval%20fantasy%20landscape%20with%20ancient%20stone%20castle%20ruins%20on%20a%20misty%20mountain%2C%20a%20lone%20figure%20with%20silver%20hair%20walking%20through%20foggy%20forest%2C%20dark%20stormy%20sky%20with%20silver%20light%20breaking%20through%2C%20professional%20cinematic%20fantasy%20photography%2C%20atmospheric%20and%20mysterious&width=1600&height=900&seq=tw-banner-09&orientation=landscape',
    categories: ['action', 'scifi', 'drama'],
    rating: 8.5,
    year: 2019,
    seasons: 3,
    episodes: 24,
    status: '连载中',
    description: '《猎魔人》改编自安德烈·斯帕克沃斯基的同名奇幻小说系列，讲述了猎魔人杰洛特在充满怪物和魔法的大陆上冒险的故事。亨利·卡维尔的精彩演绎让这个角色深入人心，宏大的世界观和精彩的动作场面令人目不暇接。',
    featured: false,
    latest: true,
    latestEpisode: '第三季 第8集',
    updateTime: '2025-11-10',
    director: '劳伦·施密特',
    cast: ['亨利·卡维尔', '安雅·查洛特拉', '芙蕾雅·艾伦', '乔伊·贝蒂', '米安娜·伯宁'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `命运之剑 - 第${i + 1}集` })) },
      { season: 3, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `第三季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 10,
    name: '杀死伊芙',
    englishName: 'Killing Eve',
    poster: 'https://readdy.ai/api/search-image?query=Stylish%20spy%20thriller%20television%20series%20poster%20featuring%20two%20women%20facing%20each%20other%20with%20intense%20gaze%2C%20one%20elegant%20in%20designer%20dress%20the%20other%20in%20casual%20attire%2C%20dramatic%20split%20composition%20with%20bold%20crimson%20and%20deep%20navy%20blue%20contrast%2C%20sophisticated%20European%20aesthetic%2C%20fashion%20editorial%20style%20professional%20poster%20with%20psychological%20tension&width=800&height=1200&seq=ke-poster-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20moody%20European%20city%20street%20at%20twilight%2C%20wet%20cobblestones%20reflecting%20neon%20lights%2C%20elegant%20figure%20in%20designer%20coat%20walking%20through%20the%20rain%2C%20stylish%20spy%20thriller%20atmosphere%2C%20rich%20cinematic%20composition%20with%20dramatic%20lighting%2C%20professional%20film%20photography&width=1600&height=900&seq=ke-banner-10&orientation=landscape',
    categories: ['crime', 'suspense', 'drama'],
    rating: 8.9,
    year: 2018,
    seasons: 4,
    episodes: 32,
    status: '已完结',
    description: '《杀死伊芙》讲述了一名英国军情五处的文职人员与一名优雅而致命的女杀手之间展开的猫鼠游戏。两人之间的致命吸引力让这场追捕变得异常复杂，吴珊卓和朱迪·科默的对手戏堪称经典。',
    featured: false,
    latest: false,
    latestEpisode: '第四季 第8集',
    updateTime: '2022-04-10',
    director: '菲比·沃勒-布里奇',
    cast: ['吴珊卓', '朱迪·科默', '菲奥娜·肖', '金·波德尼亚', '欧文·麦克唐纳'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `初见 - 第${i + 1}集` })) },
      { season: 4, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `终局 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 11,
    name: '真探',
    englishName: 'True Detective',
    poster: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20anthology%20television%20series%20poster%20featuring%20two%20detectives%20in%20silhouette%20standing%20in%20a%20dark%20Louisiana%20bayou%20at%20dusk%2C%20mysterious%20occult%20symbols%20faintly%20glowing%20in%20the%20background%2C%20deep%20forest%20green%20and%20muted%20gold%20tones%2C%20atmospheric%20southern%20gothic%20aesthetic%2C%20professional%20cinematic%20poster%20with%20haunting%20psychological%20thriller%20atmosphere&width=800&height=1200&seq=td-poster-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20eerie%20Louisiana%20bayou%20at%20twilight%2C%20cypress%20trees%20draped%20in%20spanish%20moss%2C%20mysterious%20fog%20rolling%20over%20dark%20water%2C%20a%20lone%20dirt%20road%20disappearing%20into%20the%20swamp%2C%20southern%20gothic%20atmosphere%2C%20professional%20film%20photography%20with%20haunting%20mood&width=1600&height=900&seq=td-banner-11&orientation=landscape',
    categories: ['crime', 'suspense', 'drama'],
    rating: 9.1,
    year: 2014,
    seasons: 4,
    episodes: 30,
    status: '连载中',
    description: '《真探》是一部独立单元犯罪剧集，每季讲述一个完整的案件故事。第一季由马修·麦康纳和伍迪·哈里森主演，以其阴郁的氛围、哲学对话和精湛的表演被誉为电视剧史上的里程碑之作。',
    featured: false,
    latest: true,
    latestEpisode: '第四季 第6集',
    updateTime: '2025-12-01',
    director: '尼克·皮佐拉托',
    cast: ['马修·麦康纳', '伍迪·哈里森', '科林·法瑞尔', '瑞秋·麦克亚当斯', '朱迪·福斯特'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `漫长的光明 - 第${i + 1}集` })) },
      { season: 4, episodes: Array.from({ length: 6 }, (_, i) => ({ num: i + 1, title: `夜之国 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 12,
    name: '继承之战',
    englishName: 'Succession',
    poster: 'https://readdy.ai/api/search-image?query=Corporate%20drama%20television%20series%20poster%20featuring%20a%20fractured%20family%20portrait%20of%20wealthy%20business%20elite%20in%20formal%20attire%20standing%20in%20a%20luxurious%20modern%20glass%20penthouse%2C%20cold%20corporate%20power%20atmosphere%2C%20muted%20charcoal%20and%20champagne%20gold%20tones%2C%20sharp%20contemporary%20aesthetic%2C%20professional%20poster%20with%20tension%20and%20ambition%2C%20high%20society%20drama&width=800&height=1200&seq=sc-poster-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20luxurious%20modern%20glass%20skyscraper%20in%20Manhattan%20skyline%20at%20golden%20hour%2C%20reflecting%20clouds%20and%20city%20lights%2C%20cold%20corporate%20power%20aesthetic%2C%20wealthy%20elite%20atmosphere%2C%20professional%20architectural%20photography%20with%20dramatic%20lighting&width=1600&height=900&seq=sc-banner-12&orientation=landscape',
    categories: ['drama', 'comedy'],
    rating: 9.2,
    year: 2018,
    seasons: 4,
    episodes: 39,
    status: '已完结',
    description: '《继承之战》围绕媒体巨头罗伊家族展开，讲述了年迈的 patriarch 即将退位时，四个子女为争夺家族企业控制权而展开的明争暗斗。犀利的对白、精湛的群戏和黑色幽默让这部商战剧成为HBO的又一经典。',
    featured: false,
    latest: false,
    latestEpisode: '第四季 第10集',
    updateTime: '2023-05-28',
    director: '杰西·阿姆斯特朗',
    cast: ['布莱恩·考克斯', '杰瑞米·斯特朗', '莎拉·斯努克', '基南·卡尔金', '马修·麦克费登'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 10 }, (_, i) => ({ num: i + 1, title: `王位之争 - 第${i + 1}集` })) },
      { season: 4, episodes: Array.from({ length: 10 }, (_, i) => ({ num: i + 1, title: `终章 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 13,
    name: '白莲花度假村',
    englishName: 'The White Lotus',
    poster: 'https://readdy.ai/api/search-image?query=Tropical%20dark%20comedy%20drama%20television%20series%20poster%20featuring%20a%20luxurious%20beachfront%20resort%20with%20palm%20trees%20silhouetted%20against%20a%20dramatic%20turquoise%20and%20coral%20sunset%20sky%2C%20subtle%20hints%20of%20tension%20beneath%20the%20paradise%20surface%2C%20vibrant%20tropical%20palette%20with%20mysterious%20undertones%2C%20professional%20cinematic%20poster%20with%20satirical%20social%20commentary%20atmosphere&width=800&height=1200&seq=wl-poster-13&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20stunning%20tropical%20luxury%20resort%20with%20infinity%20pool%20overlooking%20turquoise%20ocean%20at%20golden%20sunset%2C%20palm%20trees%20swaying%2C%20beautiful%20but%20unsettling%20paradise%20atmosphere%2C%20professional%20travel%20photography%20with%20subtle%20dark%20undertones&width=1600&height=900&seq=wl-banner-13&orientation=landscape',
    categories: ['comedy', 'drama', 'suspense'],
    rating: 8.8,
    year: 2021,
    seasons: 3,
    episodes: 21,
    status: '连载中',
    description: '《白莲花度假村》以一间豪华度假酒店为舞台，讲述了一群富有客人和酒店员工在一周假期中发生的各种故事。剧集以黑色幽默的手法揭示了阶级、特权和人性中的阴暗面，配乐和摄影都极其出色。',
    featured: false,
    latest: true,
    latestEpisode: '第三季 第8集',
    updateTime: '2025-12-20',
    director: '迈克·怀特',
    cast: ['詹妮弗·库利奇', '强·格瑞斯', '奥布瑞·普拉扎', '迈克尔·因佩里奥利', '西奥·詹姆斯'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 6 }, (_, i) => ({ num: i + 1, title: `抵达 - 第${i + 1}集` })) },
      { season: 3, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `第三季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 14,
    name: '熊家餐馆',
    englishName: 'The Bear',
    poster: 'https://readdy.ai/api/search-image?query=Intense%20culinary%20drama%20television%20series%20poster%20featuring%20a%20close%20up%20of%20hands%20working%20with%20ingredients%20on%20a%20stainless%20steel%20kitchen%20counter%2C%20warm%20overhead%20lighting%20casting%20dramatic%20shadows%20in%20a%20professional%20kitchen%2C%20rich%20amber%20and%20cream%20tones%20with%20industrial%20textures%2C%20gritty%20realistic%20food%20culture%20aesthetic%2C%20professional%20poster%20with%20raw%20energy%20and%20passion&width=800&height=1200&seq=tb-poster-14&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20busy%20professional%20restaurant%20kitchen%20with%20stainless%20steel%20surfaces%20under%20warm%20industrial%20lighting%2C%20steam%20rising%20from%20pots%2C%20organized%20chaos%20of%20culinary%20craft%2C%20gritty%20realistic%20food%20industry%20atmosphere%2C%20professional%20documentary%20photography%20style&width=1600&height=900&seq=tb-banner-14&orientation=landscape',
    categories: ['comedy', 'drama'],
    rating: 9.0,
    year: 2022,
    seasons: 3,
    episodes: 28,
    status: '连载中',
    description: '《熊家餐馆》讲述了一位米其林星级餐厅的年轻厨师回到芝加哥接手已故哥哥的三明治店的故事。剧集以极其真实的厨房场景、快速剪辑和炸裂的表演展现了餐饮行业的压力与温情，是近年最令人惊喜的美剧之一。',
    featured: false,
    latest: true,
    latestEpisode: '第三季 第10集',
    updateTime: '2025-12-08',
    director: '克里斯托弗·斯托勒',
    cast: ['杰瑞米·艾伦·怀特', '艾邦·摩斯-巴克拉赫', '阿约·埃德比里', '莱昂内尔·博伊斯', '丽莎·科隆-扎亚斯'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `系统 - 第${i + 1}集` })) },
      { season: 3, episodes: Array.from({ length: 10 }, (_, i) => ({ num: i + 1, title: `第三季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 15,
    name: '辐射',
    englishName: 'Fallout',
    poster: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20retro%20futurism%20television%20series%20poster%20featuring%20a%20vault%20dweller%20in%20blue%20jumpsuit%20emerging%20from%20an%20underground%20vault%20door%20into%20a%20devastated%20wasteland%2C%201950s%20atomic%20age%20aesthetic%20with%20rusted%20retro%20technology%2C%20warm%20sepia%20and%20muted%20teal%20tones%2C%20dark%20humor%20adventure%20atmosphere%2C%20professional%20cinematic%20poster%20with%20vintage%20sci%20fi%20style&width=800&height=1200&seq=fo-poster-15&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20vast%20post%20apocalyptic%20wasteland%20with%20rusted%20retro%20futuristic%20structures%20under%20a%20hazy%20sepia%20sky%2C%20a%20lone%20figure%20in%20blue%20vault%20suit%20walking%20through%20ruins%2C%20vintage%201950s%20atomic%20age%20aesthetic%2C%20dark%20humor%20adventure%20atmosphere%2C%20professional%20cinematic%20photography&width=1600&height=900&seq=fo-banner-15&orientation=landscape',
    categories: ['scifi', 'action', 'comedy'],
    rating: 8.6,
    year: 2024,
    seasons: 2,
    episodes: 16,
    status: '连载中',
    description: '《辐射》改编自同名经典游戏系列，设定在核战后的废土世界。剧集完美还原了游戏独特的复古未来主义美学和黑色幽默风格，讲述了几位幸存者穿越荒原的冒险故事，对游戏粉丝和新观众都极具吸引力。',
    featured: false,
    latest: true,
    latestEpisode: '第二季 第8集',
    updateTime: '2025-12-18',
    director: '乔纳森·诺兰 / 丽莎·乔伊',
    cast: ['艾拉·珀内尔', '沃尔顿·戈金斯', '亚伦·莫顿', '凯尔·麦克拉克伦', '莫伊塞斯·阿里亚斯'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `废土之旅 - 第${i + 1}集` })) },
      { season: 2, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `第二季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 16,
    name: '浴血黑帮',
    englishName: 'Peaky Blinders',
    poster: 'https://readdy.ai/api/search-image?query=Period%20crime%20drama%20television%20series%20poster%20featuring%20a%20sharply%20dressed%20man%20in%201920s%20flat%20cap%20and%20tailored%20overcoat%20walking%20through%20a%20smoky%20industrial%20Birmingham%20street%2C%20muted%20sepia%20and%20charcoal%20tones%20with%20warm%20amber%20light%20cutting%20through%20fog%2C%20gritty%20historical%20gangster%20aesthetic%2C%20professional%20cinematic%20poster%20with%20intense%20brooding%20atmosphere&width=800&height=1200&seq=pb-poster-16&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%201920s%20industrial%20Birmingham%20England%20street%20with%20brick%20factories%20and%20smokestacks%20against%20a%20moody%20gray%20sky%2C%20horse%20drawn%20carriages%20on%20cobblestone%2C%20atmospheric%20fog%20and%20smoke%2C%20gritty%20historical%20period%20aesthetic%2C%20professional%20film%20photography&width=1600&height=900&seq=pb-banner-16&orientation=landscape',
    categories: ['crime', 'drama', 'action'],
    rating: 8.9,
    year: 2013,
    seasons: 6,
    episodes: 36,
    status: '已完结',
    description: '《浴血黑帮》以1919年一战后的英国伯明翰为背景，讲述了谢尔比家族黑帮的崛起历程。基里安·墨菲饰演的汤米·谢尔比成为荧幕经典，剧集以其精美的服装、震撼的配乐和硬核的剧情征服了全球观众。',
    featured: false,
    latest: false,
    latestEpisode: '第六季 第6集',
    updateTime: '2022-04-03',
    director: '斯蒂文·奈特',
    cast: ['基里安·墨菲', '海伦·麦克洛瑞', '保罗·安德森', '汤姆·哈迪', '安雅·泰勒-乔伊'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 6 }, (_, i) => ({ num: i + 1, title: `崛起 - 第${i + 1}集` })) },
      { season: 6, episodes: Array.from({ length: 6 }, (_, i) => ({ num: i + 1, title: `终章 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 17,
    name: '曼达洛人',
    englishName: 'The Mandalorian',
    poster: 'https://readdy.ai/api/search-image?query=Space%20western%20television%20series%20poster%20featuring%20a%20lone%20armored%20bounty%20hunter%20walking%20across%20a%20vast%20desert%20alien%20planet%20with%20twin%20suns%20setting%20on%20the%20horizon%2C%20warm%20golden%20and%20rust%20tones%20with%20sleek%20metallic%20silver%20armor%20contrast%2C%20classic%20western%20composition%20in%20science%20fiction%20setting%2C%20professional%20cinematic%20poster%20with%20epic%20adventure%20atmosphere&width=800&height=1200&seq=md-poster-17&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20vast%20alien%20desert%20landscape%20with%20twin%20suns%20setting%2C%20a%20lone%20spaceship%20parked%20on%20a%20rocky%20ridge%2C%20warm%20golden%20and%20rust%20colored%20sky%2C%20classic%20western%20meets%20science%20fiction%20aesthetic%2C%20professional%20cinematic%20photography%2C%20epic%20scale&width=1600&height=900&seq=md-banner-17&orientation=landscape',
    categories: ['action', 'scifi'],
    rating: 8.8,
    year: 2019,
    seasons: 3,
    episodes: 24,
    status: '连载中',
    description: '《曼达洛人》是星球大战宇宙的首部真人剧集，讲述了一位孤独的曼达洛赏金猎人在银河系边缘的冒险故事。剧集以Baby Yoda（古古）这一角色风靡全球，将西部片的叙事风格与科幻完美结合。',
    featured: false,
    latest: true,
    latestEpisode: '第三季 第8集',
    updateTime: '2025-11-05',
    director: '乔恩·费儒',
    cast: ['佩德罗·帕斯卡', '凯蒂·萨克霍夫', '吉安卡罗·埃斯波西托', '卡尔·韦瑟斯', '艾米莉·斯瓦洛'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `赏金猎人 - 第${i + 1}集` })) },
      { season: 3, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `第三季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 18,
    name: '纸牌屋',
    englishName: 'House of Cards',
    poster: 'https://readdy.ai/api/search-image?query=Political%20drama%20television%20series%20poster%20featuring%20an%20inverted%20American%20flag%20with%20blood%20red%20stripes%20dripping%20downward%20against%20a%20dark%20marble%20government%20building%20background%2C%20cold%20power%20hungry%20atmosphere%2C%20deep%20crimson%20navy%20and%20charcoal%20tones%2C%20minimalist%20professional%20poster%20with%20corrupt%20political%20intrigue%20aesthetic&width=800&height=1200&seq=hoc-poster-18&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20Washington%20DC%20Capitol%20building%20at%20night%20with%20dramatic%20storm%20clouds%20gathering%20overhead%2C%20dark%20and%20moody%20political%20power%20atmosphere%2C%20cold%20institutional%20aesthetic%2C%20professional%20architectural%20photography%20with%20ominous%20tone&width=1600&height=900&seq=hoc-banner-18&orientation=landscape',
    categories: ['drama', 'crime', 'suspense'],
    rating: 9.0,
    year: 2013,
    seasons: 6,
    episodes: 73,
    status: '已完结',
    description: '《纸牌屋》讲述了美国国会众议员弗兰克·安德伍德在政治权力游戏中不择手段向上爬的故事。凯文·史派西通过打破第四面墙的表演方式让观众成为其阴谋的共谋者，开创了流媒体剧集的新纪元。',
    featured: false,
    latest: false,
    latestEpisode: '第六季 第8集',
    updateTime: '2018-11-02',
    director: '大卫·芬奇',
    cast: ['凯文·史派西', '罗宾·怀特', '迈克尔·凯利', '寇瑞·斯托尔', '凯特·玛拉'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 13 }, (_, i) => ({ num: i + 1, title: `权力的阶梯 - 第${i + 1}集` })) },
      { season: 6, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `终章 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 19,
    name: '最后生还者',
    englishName: 'The Last of Us',
    poster: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20drama%20television%20series%20poster%20featuring%20a%20grizzled%20survivor%20and%20a%20young%20girl%20walking%20through%20an%20overgrown%20abandoned%20city%20street%20with%20nature%20reclaiming%20buildings%2C%20warm%20golden%20sunlight%20filtering%20through%20vegetation%2C%20emotional%20journey%20aesthetic%2C%20muted%20green%20and%20golden%20tones%2C%20professional%20cinematic%20poster%20with%20deep%20human%20connection%20and%20survival%20atmosphere&width=800&height=1200&seq=tlou-poster-19&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20post%20apocalyptic%20city%20overtaken%20by%20lush%20green%20nature%2C%20abandoned%20skyscrapers%20covered%20in%20vines%20under%20warm%20golden%20sunlight%2C%20beautiful%20haunting%20atmosphere%2C%20nature%20reclaiming%20civilization%2C%20professional%20film%20photography%20with%20emotional%20depth&width=1600&height=900&seq=tlou-banner-19&orientation=landscape',
    categories: ['drama', 'action', 'scifi'],
    rating: 9.2,
    year: 2023,
    seasons: 2,
    episodes: 17,
    status: '连载中',
    description: '《最后生还者》改编自同名获奖游戏，讲述了在真菌感染导致的末日世界中，硬汉乔尔护送少女艾莉穿越美国的感人故事。佩德罗·帕斯卡和贝拉·拉姆齐的表演令人动容，被誉为游戏改编影视的天花板。',
    featured: false,
    latest: true,
    latestEpisode: '第二季 第9集',
    updateTime: '2025-12-22',
    director: '克雷格·麦辛 / 尼尔·德鲁克曼',
    cast: ['佩德罗·帕斯卡', '贝拉·拉姆齐', '加布里埃尔·鲁纳', '梅尔·丹德里奇', '安娜·托芙'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 9 }, (_, i) => ({ num: i + 1, title: `当你在黑暗中迷失 - 第${i + 1}集` })) },
      { season: 2, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `第二季 - 第${i + 1}集` })) },
    ],
  },
  {
    id: 20,
    name: '黑暗物质',
    englishName: 'His Dark Materials',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20television%20series%20poster%20featuring%20a%20young%20girl%20with%20a%20shape%20shifting%20animal%20companion%20standing%20at%20the%20edge%20of%20a%20glowing%20portal%20to%20another%20world%2C%20parallel%20universe%20concept%20with%20warm%20golden%20light%20and%20deep%20mysterious%20blue%20tones%2C%20magical%20atmosphere%20with%20steampunk%20elements%2C%20professional%20cinematic%20fantasy%20poster%20with%20grand%20adventure%20scale&width=800&height=1200&seq=hdm-poster-20&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20magical%20fantasy%20landscape%20with%20a%20glowing%20aurora%20portal%20opening%20above%20snow%20covered%20mountains%2C%20a%20majestic%20armored%20polar%20bear%20walking%20through%20a%20frozen%20arctic%20landscape%2C%20epic%20fantasy%20adventure%20atmosphere%2C%20professional%20cinematic%20photography&width=1600&height=900&seq=hdm-banner-20&orientation=landscape',
    categories: ['scifi', 'action', 'drama'],
    rating: 8.3,
    year: 2019,
    seasons: 3,
    episodes: 23,
    status: '已完结',
    description: '《黑暗物质》改编自菲利普·普尔曼的同名奇幻小说三部曲，讲述了少女莱拉穿越多个平行世界寻找真相的冒险故事。剧集以其宏大的世界观、精美的视觉效果和深刻的哲学主题赢得了观众的喜爱。',
    featured: false,
    latest: false,
    latestEpisode: '第三季 第8集',
    updateTime: '2023-02-05',
    director: '杰克·索恩',
    cast: ['达芙妮·基恩', '露丝·威尔森', '詹姆斯·麦卡沃伊', '林-曼努尔·米兰达', '安德鲁·斯科特'],
    episodeList: [
      { season: 1, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `黄金罗盘 - 第${i + 1}集` })) },
      { season: 3, episodes: Array.from({ length: 8 }, (_, i) => ({ num: i + 1, title: `最终季 - 第${i + 1}集` })) },
    ],
  },
];

export const heroShow = tvShows.find(s => s.featured && s.id === 1)!;